(function () {
  'use strict';

  if (window.__ANER_FORM_I18N_ACTIVE__) return;
  window.__ANER_FORM_I18N_ACTIVE__ = true;

  var FORM_ID = '102482';
  var LOCALES = ['de', 'fr', 'es', 'it'];
  var REQUIRED_SUFFIX = { de: 'ist erforderlich', fr: 'est obligatoire', es: 'es obligatorio', it: 'è obbligatorio' };
  var TRANSLATIONS = {
    de: {
      text: {
        'Contact us': 'Kontaktieren Sie uns',
        "Leave your message and we'll get back to you shortly.": 'Hinterlassen Sie uns Ihre Nachricht – wir melden uns in Kürze bei Ihnen.',
        'Your Name': 'Ihr Name',
        'Email': 'E-Mail',
        'Message': 'Nachricht',
        'Upload Your Design (Optional)': 'Design hochladen (optional)',
        'Choose file or drag here': 'Datei auswählen oder hierher ziehen',
        'Supported format: JPG, JPEG, PNG, GIF, SVG.': 'Unterstützte Formate: JPG, JPEG, PNG, GIF, SVG.',
        'Browse file': 'Datei auswählen',
        'Previous': 'Zurück',
        'Next': 'Weiter',
        'Submit': 'Absenden',
        'Thanks for getting in touch!': 'Vielen Dank für Ihre Nachricht!',
        'Thank you for submitting your information.': 'Vielen Dank für die Übermittlung Ihrer Informationen.',
        'We will respond to your inquiry within 24 hours. If not, please': 'Wir antworten auf Ihre Anfrage innerhalb von 24 Stunden. Falls nicht, bitte',
        'check your spam or junk folder': 'prüfen Sie Ihren Spam- oder Junk-Ordner',
        'Uploading...': 'Wird hochgeladen...',
        'Remove': 'Entfernen',
        'Drop files here': 'Dateien hier ablegen',
        'Maximum file size': 'Maximale Dateigröße',
        'File type not allowed': 'Dateityp nicht zulässig',
        'Please login to continue': 'Bitte melden Sie sich an, um fortzufahren.'
      },
      errors: {
        'required': '{{ label | capitalize }} ist erforderlich',
        'minSelections': 'Bitte wählen Sie mindestens {{ min_selections }} Optionen aus',
        'maxSelections': 'Bitte wählen Sie höchstens {{ max_selections }} Optionen aus',
        'exactlySelections': 'Bitte wählen Sie genau {{ exact_selections }} Optionen aus',
        'minProductSelections': 'Bitte wählen Sie mindestens {{ min_selections }} Produkte aus',
        'maxProductSelections': 'Bitte wählen Sie höchstens {{ max_selections }} Produkte aus',
        'minProductQuantities': 'Bitte wählen Sie eine Menge von mindestens {{ min_quantities }} Produkten aus',
        'maxProductQuantities': 'Bitte wählen Sie eine Menge von höchstens {{ max_quantities }} Produkten aus',
        'minEachProductQuantities': 'Wählen Sie für {{product_name}} eine Menge von mindestens {{min_quantities}}',
        'maxEachProductQuantities': 'Wählen Sie für {{product_name}} eine Menge von höchstens {{max_quantities}}',
        'invalid': 'Ungültig',
        'invalidName': 'Ungültiger Name',
        'invalidEmail': 'Die E-Mail-Adresse ist ungültig',
        'restrictedEmailDomain': 'Diese E-Mail-Domain ist nicht zulässig',
        'invalidURL': 'Ungültige URL',
        'invalidPhone': 'Ungültige Telefonnummer',
        'invalidNumber': 'Ungültige Zahl',
        'invalidPassword': 'Ungültiges Passwort',
        'confirmPasswordNotMatch': 'Die Passwörter stimmen nicht überein',
        'customerAlreadyExists': 'Kunde existiert bereits',
        'keyAlreadyExists': 'Daten existieren bereits',
        'fileSizeLimit': 'Dateigröße überschritten',
        'fileNotAllowed': 'Dateityp nicht zulässig',
        'requiredCaptcha': 'Captcha erforderlich',
        'requiredProducts': 'Bitte wählen Sie ein Produkt aus',
        'limitQuantity': 'Die verfügbare Lagermenge wurde überschritten',
        'shopifyInvalidPhone': 'Telefon – Geben Sie eine gültige Telefonnummer ein, um diese Liefermethode zu verwenden',
        'shopifyPhoneHasAlready': 'Telefon – Diese Telefonnummer wird bereits verwendet',
        'shopifyInvalidProvice': 'Adresse/Bundesland – ungültig',
        'otherError': 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
        'limitNumberOfSubmissions': 'Maximale Anzahl an Formulareinsendungen erreicht'
      },
      successHtml: '<p><strong>Vielen Dank für die Übermittlung Ihrer Informationen.</strong></p><p>Wir antworten auf Ihre Anfrage innerhalb von 24 Stunden. Falls nicht, prüfen Sie bitte Ihren Spam- oder Junk-Ordner.</p>'
    },
    fr: {
      text: {
        'Contact us': 'Contactez-nous',
        "Leave your message and we'll get back to you shortly.": 'Laissez-nous votre message, nous vous répondrons rapidement.',
        'Your Name': 'Votre nom',
        'Email': 'E-mail',
        'Message': 'Message',
        'Upload Your Design (Optional)': 'Téléversez votre design (facultatif)',
        'Choose file or drag here': 'Choisissez un fichier ou glissez-le ici',
        'Supported format: JPG, JPEG, PNG, GIF, SVG.': 'Formats pris en charge : JPG, JPEG, PNG, GIF, SVG.',
        'Browse file': 'Choisir un fichier',
        'Previous': 'Précédent',
        'Next': 'Suivant',
        'Submit': 'Envoyer',
        'Thanks for getting in touch!': 'Merci de nous avoir contactés !',
        'Thank you for submitting your information.': "Merci d'avoir envoyé vos informations.",
        'We will respond to your inquiry within 24 hours. If not, please': 'Nous répondrons à votre demande sous 24 heures. Si vous ne recevez pas de réponse, veuillez',
        'check your spam or junk folder': 'vérifier votre dossier spam ou courrier indésirable',
        'Uploading...': 'Téléchargement...',
        'Remove': 'Supprimer',
        'Drop files here': 'Déposez les fichiers ici',
        'Maximum file size': 'Taille maximale du fichier',
        'File type not allowed': 'Type de fichier non autorisé',
        'Please login to continue': 'Veuillez vous connecter pour continuer.'
      },
      errors: {
        'required': '{{ label | capitalize }} est obligatoire',
        'minSelections': 'Veuillez choisir au moins {{ min_selections }} options',
        'maxSelections': 'Veuillez choisir au maximum {{ max_selections }} options',
        'exactlySelections': 'Veuillez choisir exactement {{ exact_selections }} options',
        'minProductSelections': 'Veuillez choisir au moins {{ min_selections }} produits',
        'maxProductSelections': 'Veuillez choisir au maximum {{ max_selections }} produits',
        'minProductQuantities': "Veuillez choisir une quantité d'au moins {{ min_quantities }} produits",
        'maxProductQuantities': 'Veuillez choisir une quantité de {{ max_quantities }} produits au maximum',
        'minEachProductQuantities': "Choisissez une quantité d'au moins {{min_quantities}} pour {{product_name}}",
        'maxEachProductQuantities': 'Choisissez une quantité de {{max_quantities}} au maximum pour {{product_name}}',
        'invalid': 'Non valide',
        'invalidName': 'Nom non valide',
        'invalidEmail': "L'adresse e-mail est non valide",
        'restrictedEmailDomain': 'Ce domaine e-mail est restreint',
        'invalidURL': 'URL non valide',
        'invalidPhone': 'Numéro de téléphone non valide',
        'invalidNumber': 'Nombre non valide',
        'invalidPassword': 'Mot de passe non valide',
        'confirmPasswordNotMatch': 'Les mots de passe ne correspondent pas',
        'customerAlreadyExists': 'Le client existe déjà',
        'keyAlreadyExists': 'Les données existent déjà',
        'fileSizeLimit': 'Taille du fichier dépassée',
        'fileNotAllowed': 'Type de fichier non autorisé',
        'requiredCaptcha': 'Captcha obligatoire',
        'requiredProducts': 'Veuillez sélectionner un produit',
        'limitQuantity': 'La quantité disponible en stock a été dépassée',
        'shopifyInvalidPhone': 'Téléphone – Saisissez un numéro valide pour utiliser ce mode de livraison',
        'shopifyPhoneHasAlready': 'Téléphone – Ce numéro est déjà utilisé',
        'shopifyInvalidProvice': 'Adresse/province – non valide',
        'otherError': 'Une erreur est survenue. Veuillez réessayer.',
        'limitNumberOfSubmissions': 'Limite de soumissions du formulaire atteinte'
      },
      successHtml: "<p><strong>Merci d'avoir envoyé vos informations.</strong></p><p>Nous répondrons à votre demande sous 24 heures. Si vous ne recevez pas de réponse, veuillez vérifier votre dossier spam ou courrier indésirable.</p>"
    },
    es: {
      text: {
        'Contact us': 'Contáctanos',
        "Leave your message and we'll get back to you shortly.": 'Déjanos tu mensaje y te responderemos en breve.',
        'Your Name': 'Tu nombre',
        'Email': 'Correo electrónico',
        'Message': 'Mensaje',
        'Upload Your Design (Optional)': 'Sube tu diseño (opcional)',
        'Choose file or drag here': 'Elige un archivo o arrástralo aquí',
        'Supported format: JPG, JPEG, PNG, GIF, SVG.': 'Formatos compatibles: JPG, JPEG, PNG, GIF, SVG.',
        'Browse file': 'Elegir archivo',
        'Previous': 'Anterior',
        'Next': 'Siguiente',
        'Submit': 'Enviar',
        'Thanks for getting in touch!': '¡Gracias por contactarnos!',
        'Thank you for submitting your information.': 'Gracias por enviar tu información.',
        'We will respond to your inquiry within 24 hours. If not, please': 'Responderemos a tu consulta en un plazo de 24 horas. Si no recibes respuesta, por favor',
        'check your spam or junk folder': 'revisa tu carpeta de spam o correo no deseado',
        'Uploading...': 'Subiendo...',
        'Remove': 'Eliminar',
        'Drop files here': 'Suelta los archivos aquí',
        'Maximum file size': 'Tamaño máximo del archivo',
        'File type not allowed': 'Tipo de archivo no permitido',
        'Please login to continue': 'Inicia sesión para continuar.'
      },
      errors: {
        'required': '{{ label | capitalize }} es obligatorio',
        'minSelections': 'Elige al menos {{ min_selections }} opciones',
        'maxSelections': 'Elige como máximo {{ max_selections }} opciones',
        'exactlySelections': 'Elige exactamente {{ exact_selections }} opciones',
        'minProductSelections': 'Elige al menos {{ min_selections }} productos',
        'maxProductSelections': 'Elige como máximo {{ max_selections }} productos',
        'minProductQuantities': 'Elige una cantidad de al menos {{ min_quantities }} productos',
        'maxProductQuantities': 'Elige una cantidad de no más de {{ max_quantities }} productos',
        'minEachProductQuantities': 'Elige una cantidad de al menos {{min_quantities}} de {{product_name}}',
        'maxEachProductQuantities': 'Elige una cantidad de no más de {{max_quantities}} de {{product_name}}',
        'invalid': 'No válido',
        'invalidName': 'Nombre no válido',
        'invalidEmail': 'La dirección de correo electrónico no es válida',
        'restrictedEmailDomain': 'Este dominio de correo está restringido',
        'invalidURL': 'URL no válida',
        'invalidPhone': 'Teléfono no válido',
        'invalidNumber': 'Número no válido',
        'invalidPassword': 'Contraseña no válida',
        'confirmPasswordNotMatch': 'Las contraseñas no coinciden',
        'customerAlreadyExists': 'El cliente ya existe',
        'keyAlreadyExists': 'Los datos ya existen',
        'fileSizeLimit': 'Se superó el tamaño máximo del archivo',
        'fileNotAllowed': 'Tipo de archivo no permitido',
        'requiredCaptcha': 'Captcha obligatorio',
        'requiredProducts': 'Selecciona un producto',
        'limitQuantity': 'Se superó la cantidad disponible en stock',
        'shopifyInvalidPhone': 'Teléfono: introduce un número válido para usar este método de envío',
        'shopifyPhoneHasAlready': 'Teléfono: este número ya está en uso',
        'shopifyInvalidProvice': 'Dirección/provincia: no válida',
        'otherError': 'Algo salió mal. Inténtalo de nuevo.',
        'limitNumberOfSubmissions': 'Se alcanzó el límite de envíos del formulario'
      },
      successHtml: '<p><strong>Gracias por enviar tu información.</strong></p><p>Responderemos a tu consulta en un plazo de 24 horas. Si no recibes respuesta, revisa tu carpeta de spam o correo no deseado.</p>'
    },
    it: {
      text: {
        'Contact us': 'Contattaci',
        "Leave your message and we'll get back to you shortly.": 'Lasciaci il tuo messaggio, ti risponderemo a breve.',
        'Your Name': 'Il tuo nome',
        'Email': 'Email',
        'Message': 'Messaggio',
        'Upload Your Design (Optional)': 'Carica il tuo design (facoltativo)',
        'Choose file or drag here': 'Scegli un file o trascinalo qui',
        'Supported format: JPG, JPEG, PNG, GIF, SVG.': 'Formati supportati: JPG, JPEG, PNG, GIF, SVG.',
        'Browse file': 'Scegli file',
        'Previous': 'Indietro',
        'Next': 'Avanti',
        'Submit': 'Invia',
        'Thanks for getting in touch!': 'Grazie per averci contattato!',
        'Thank you for submitting your information.': 'Grazie per aver inviato le tue informazioni.',
        'We will respond to your inquiry within 24 hours. If not, please': 'Risponderemo alla tua richiesta entro 24 ore. Se non ricevi risposta,',
        'check your spam or junk folder': 'controlla la cartella spam o posta indesiderata',
        'Uploading...': 'Caricamento...',
        'Remove': 'Rimuovi',
        'Drop files here': 'Trascina qui i file',
        'Maximum file size': 'Dimensione massima del file',
        'File type not allowed': 'Tipo di file non consentito',
        'Please login to continue': 'Accedi per continuare.'
      },
      errors: {
        'required': '{{ label | capitalize }} è obbligatorio',
        'minSelections': 'Scegli almeno {{ min_selections }} opzioni',
        'maxSelections': 'Scegli al massimo {{ max_selections }} opzioni',
        'exactlySelections': 'Scegli esattamente {{ exact_selections }} opzioni',
        'minProductSelections': 'Scegli almeno {{ min_selections }} prodotti',
        'maxProductSelections': 'Scegli al massimo {{ max_selections }} prodotti',
        'minProductQuantities': 'Scegli una quantità di almeno {{ min_quantities }} prodotti',
        'maxProductQuantities': 'Scegli una quantità non superiore a {{ max_quantities }} prodotti',
        'minEachProductQuantities': 'Scegli una quantità di almeno {{min_quantities}} per {{product_name}}',
        'maxEachProductQuantities': 'Scegli una quantità non superiore a {{max_quantities}} per {{product_name}}',
        'invalid': 'Non valido',
        'invalidName': 'Nome non valido',
        'invalidEmail': "L'indirizzo email non è valido",
        'restrictedEmailDomain': 'Questo dominio email è limitato',
        'invalidURL': 'URL non valido',
        'invalidPhone': 'Numero di telefono non valido',
        'invalidNumber': 'Numero non valido',
        'invalidPassword': 'Password non valida',
        'confirmPasswordNotMatch': 'Le password non corrispondono',
        'customerAlreadyExists': 'Il cliente esiste già',
        'keyAlreadyExists': 'I dati esistono già',
        'fileSizeLimit': 'Dimensione del file superata',
        'fileNotAllowed': 'Tipo di file non consentito',
        'requiredCaptcha': 'Captcha obbligatorio',
        'requiredProducts': 'Seleziona un prodotto',
        'limitQuantity': 'La quantità disponibile in magazzino è stata superata',
        'shopifyInvalidPhone': 'Telefono: inserisci un numero valido per usare questo metodo di consegna',
        'shopifyPhoneHasAlready': 'Telefono: questo numero è già in uso',
        'shopifyInvalidProvice': 'Indirizzo/provincia: non valido',
        'otherError': 'Si è verificato un errore. Riprova.',
        'limitNumberOfSubmissions': 'Limite di invii del modulo raggiunto'
      },
      successHtml: '<p><strong>Grazie per aver inviato le tue informazioni.</strong></p><p>Risponderemo alla tua richiesta entro 24 ore. Se non ricevi risposta, controlla la cartella spam o posta indesiderata.</p>'
    }
  };

  function detectLocale() {
    var pathParts = (window.location.pathname || '').split('/').filter(Boolean);
    var pathLocale = (pathParts[0] || '').toLowerCase();
    var htmlLocale = (document.documentElement.lang || '').toLowerCase().replace('_', '-').split('-')[0];
    var shopifyLocale = ((window.Shopify && window.Shopify.locale) || '').toLowerCase().replace('_', '-').split('-')[0];
    if (LOCALES.indexOf(pathLocale) !== -1) return pathLocale;
    if (LOCALES.indexOf(htmlLocale) !== -1) return htmlLocale;
    if (LOCALES.indexOf(shopifyLocale) !== -1) return shopifyLocale;
    return null;
  }

  var locale = detectLocale();
  if (!locale) return;

  var config = TRANSLATIONS[locale];
  if (!config) return;

  var staticPairs = Object.keys(config.text).map(function (key) {
    return [key, config.text[key]];
  }).sort(function (a, b) { return b[0].length - a[0].length; });

  var errorPairs = Object.keys(config.errors).reduce(function (pairs, key) {
    var source = config.errors[key];
    if (source.indexOf('{{') === -1 && source.indexOf('}}') === -1) pairs.push([source, config.errors[key]]);
    return pairs;
  }, []).sort(function (a, b) { return b[0].length - a[0].length; });

  var textPairs = staticPairs.concat(errorPairs);

  function replaceText(value) {
    if (!value) return value;
    var result = value;
    textPairs.forEach(function (pair) {
      if (result.indexOf(pair[0]) !== -1) result = result.split(pair[0]).join(pair[1]);
    });
    var requiredMatch = result.match(/(^\s*)(.+?)\s+is required(\s*)$/);
    if (requiredMatch && REQUIRED_SUFFIX[locale]) {
      var rawRequiredLabel = requiredMatch[2].replace(/\s*\*+\s*$/, '').trim();
      var requiredLabel = config.text[rawRequiredLabel] || rawRequiredLabel;
      if (/^this field$/i.test(rawRequiredLabel)) {
        requiredLabel = { de: 'Dieses Feld', fr: 'Ce champ', es: 'Este campo', it: 'Questo campo' }[locale];
      }
      result = requiredMatch[1] + requiredLabel + ' ' + REQUIRED_SUFFIX[locale] + requiredMatch[3];
    }
    return result;
  }
  function translateTextNode(node) {
    if (!node || !node.nodeValue) return;
    var parent = node.parentElement;
    if (parent && /^(SCRIPT|STYLE|TEXTAREA)$/i.test(parent.tagName)) return;
    var result = replaceText(node.nodeValue);
    if (result !== node.nodeValue) node.nodeValue = result;
  }

  function translateAttributes(root) {
    root.querySelectorAll('input[placeholder], textarea[placeholder], [aria-label], [title]').forEach(function (el) {
      ['placeholder', 'aria-label', 'title'].forEach(function (attr) {
        var value = el.getAttribute(attr);
        if (!value) return;
        var translated = replaceText(value);
        if (translated !== value) el.setAttribute(attr, translated);
      });
    });
  }

  function patchFormConfig() {
    var fb = window.Globo && window.Globo.FormBuilder;
    if (!fb || !fb.forms) return;
    var forms = fb.forms;
    var candidates = [forms[FORM_ID], forms[String(FORM_ID)], forms];
    candidates.forEach(function (candidate) {
      if (!candidate || typeof candidate !== 'object') return;
      if (candidate.errorMessage) {
        Object.keys(config.errors).forEach(function (key) {
          if (Object.prototype.hasOwnProperty.call(candidate.errorMessage, key)) {
            candidate.errorMessage[key] = config.errors[key];
          }
        });
      }
      if (candidate.afterSubmit && candidate.afterSubmit.message) {
        candidate.afterSubmit.message[locale] = config.successHtml;
      }
      if (candidate.footer) {
        if ('previousText' in candidate.footer) candidate.footer.previousText = config.text.Previous;
        if ('nextText' in candidate.footer) candidate.footer.nextText = config.text.Next;
        if ('submitText' in candidate.footer) candidate.footer.submitText = config.text.Submit;
      }
    });
  }

  function translateRoot(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) translateTextNode(node);
    translateAttributes(root);
    root.setAttribute('data-locale', locale);
    root.setAttribute('lang', locale);
    patchFormConfig();
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      patchFormConfig();
      translateRoot(document.querySelector('.globo-form-app[data-id="' + FORM_ID + '"]'));
    });
  }

  var observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, { subtree: true, childList: true, characterData: true });
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('load', schedule);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  var attempts = 0;
  var timer = setInterval(function () {
    attempts += 1;
    patchFormConfig();
    var root = document.querySelector('.globo-form-app[data-id="' + FORM_ID + '"]');
    if (root) translateRoot(root);
    if (attempts >= 120) clearInterval(timer);
  }, 500);
})();